import { IGroupDTOOut } from '../../interfaces/groups/group.interface';

export class GetAllGroups {
    public static readonly type = '[Groups] get all';
    constructor(public forceCall?: boolean) {}
}

export class GetGroupById {
    public static readonly type = '[Group] get one';
    constructor(public id: number) {}
}

export class CreateNewGroup {
    public static readonly type = '[Group] create';
    constructor(public newGroup: IGroupDTOOut) {}
}

export class PatchGroup {
    public static readonly type = '[Group] patch';
    constructor(public group: IGroupDTOOut) {}
}

export class DeleteGroup {
    public static readonly type = '[Group] delete';
    constructor(public groupId: number) {}
}

export class EnableGroup {
    public static readonly type = '[Group] enable';
    constructor(public groupId: number) {}
}

export class DisableGroup {
    public static readonly type = '[Group] disable';
    constructor(public groupId: number) {}
}

export class DeleteGroupToEdit {
    public static readonly type = '[Group to edit] delete';
}

export class DeleteCachedGroups {
    public static readonly type = '[Group] delete cached list';
}
